import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    // Link
} from "react-router-dom";

import Home from './Home';
import Participants from './Participants';
import Benefits from './Benefits';
// import MasterForm from './MasterForm';
import TermsAndConditions from './TermsAndConditions';

class App extends React.Component {
    // constructor(props: any) {
    //     super(props);
    // }

    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/">
                        <Home />
                    </Route>
                    {/* <Route
                        path="/application"
                        render={({ history }) => (
                            <MasterForm history={ history } />
                        )}
                    /> */}
                    <Route path="/participants">
                        <Participants />
                    </Route>
                    <Route path="/benefits">
                        <Benefits />
                    </Route>
                    <Route path="/terms-and-conditions">
                        <TermsAndConditions />
                    </Route>
                </Switch>
            </Router>
        );
    }
}

export default App;
